<div class="modal-header">
  <h2 class="modal-title">Select Fields for {{ templateName }}@if (!!groupName) {
    <span> > {{ groupName }}</span>
  }</h2>
  <button type="button" class="btn btn-close" aria-label="Cancel" (click)="cancel()" data-cy="closeTemplateFieldAdd">
    <i class="fal fa-xmark"></i>
  </button>
</div>
<div class="modal-body">
  <form class="d-flex align-items-center mb-2" (ngSubmit)="applySearch()">
    <div class="me-auto">
      <div class="input-group search-filter">
        <rl-text-input [placeholder]="'Search'" [formControl]="searchControl"
          [dataLabel]="'selectSectionFieldsSearchInput'" [ariaLabel]="'Search Fields'">
          <append-with class="d-flex">
            <button [hidden]="!searchControl.value" class="btn btn-icon btn-remove" (click)="clearSearch()"
              type="button" title="Clear Search" data-cy="selectSectionFieldsSearchRemove">
              <i class="fal fa-xmark" aria-hidden="true"></i>
            </button>
            <button type="submit" class="btn btn-icon btn-info" title="Search" data-cy="selectSectionFieldsSearchSubmit">
              <i class="fal fa-magnifying-glass" aria-hidden="true"></i>
            </button>
          </append-with>
        </rl-text-input>
      </div>
    </div>
  </form>
  <rl-checkbox-input [(ngModel)]="hideSelected" (click)="toggleHideSelected()"
    [dataLabel]="'ToggleHideSelectedCheckbox'" class="d-block mb-3"
  [label]="'Show only Fields that have not yet been placed in the Template Layout'"></rl-checkbox-input>
  <div class="table-container scroll-vert">
    <table class="table rl-table table-hover">
      <thead>
        <tr>
          <th class="ps-3">ID</th>
          <th class="text-nowrap">Field Name</th>
          <th class="text-nowrap">Tag Label</th>
          <th class="text-nowrap">Data Type</th>
          <th>System Indicator</th>
          <th>Required</th>
          <th>Multiple</th>
          <th class="text-nowrap">Conditional Field</th>
          <th class="text-nowrap">Include on Copy</th>
        </tr>
      </thead>
      <tbody>
        <tr class="no-items-message">
          <td colspan="9" class="border-0">
            <div class="d-flex align-items-center justify-content-center pt-3">
              <i class="fal fa-table-list"></i>
              <h5 class="mb-0 ms-3">No items found.</h5>
            </div>
          </td>
        </tr>
        @for (char of filteredChars; track char.characteristicID) {
          <tr cdkDrag cdkDragLockAxis="y" [cdkDragData]="char">
            <td class="text-nowrap">
              <input type="checkbox" class="form-check-input me-1" [value]="char.characteristicID"
                (change)="toggleField(char.characteristicID)"
                [checked]="isChecked(char.characteristicID)"
                [disabled]="isDisabled(char.characteristicID)"
                data-cy="checkboxInputToggleSourceField" />
                {{char.characteristicID}}
              </td>
              <td>
                {{char.label}}
              </td>
              <td>
                {{char.tagLabel}}
              </td>
              <td>
                {{char.dataTypeID | charDataTypeName}}
              </td>
              <td>
                {{char.systemIndicator}}
              </td>
              <td>
                {{char.requiredIndicator | requiredIndicatorName}}
              </td>
              <td>
                {{char.multipleIndicator | multipleIndicatorName}}
              </td>
              <td>
                {{char.triggerCharID ? "Yes" : "No"}}
              </td>
              <td>
                {{char.copyIndicator ? "Yes" : "No"}}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="bg-light py-3 px-5">
      <h4>Can't find the Field you're looking for?</h4>
      The Field must be added under
      <a [routerLink]="['/config/templates', charTypeId, 'details', templateId, 'content', 'fields']" target="_blank"
      data-cy="templateContentLink">Template Content</a>,
      then you'll be able to add it into the Template Layout.
    </div>
    <div class="border-top pt-4 mt-4">
      <h4>Selected Fields</h4>
      <div class="mt-2 chips-container scroll-vert">
        @for (charId of fieldsToAdd; track charId) {
          <rl-chip (onRemove)="toggleField(charId)">
            {{ getFieldById(charId) }}
          </rl-chip>
        }
        @if (!fieldsToAdd) {
          <span>No Fields selected.</span>
        }
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-light" (click)="cancel()" data-cy="cancelSelectionButton">Cancel
    </button>
    <button type="submit" class="btn btn-success ms-3" (click)="done()" [disabled]="fieldsToAdd.size === 0"
      data-cy="ApplySelectTemplateSourceField">Apply
    </button>
  </div>